import React from 'react';
import { useTranslation } from 'react-i18next';

import type { QWSCodelistStatus } from '~/hooks/use-qws-codelist/useQWSCodelist';

import styles from './QWSStatusView.module.scss';

export interface QWSStatusViewProps {
  status: QWSCodelistStatus;
  watchlistId?: string;
  error?: string;
  pendingNavigate?: boolean;
}

export const QWSStatusView = ({
  status,
  watchlistId,
  error,
  pendingNavigate = false,
}: QWSStatusViewProps): React.ReactElement | null => {
  const { t } = useTranslation('qws');

  const showLoading =
    status === 'loading' ||
    (status === 'done' && watchlistId) ||
    pendingNavigate;

  if (showLoading) {
    return (
      <div className={styles.wrapper}>
        <p className={styles.loadingMessage}>{t('resolving')}</p>
      </div>
    );
  }

  if (status === 'error') {
    const errorKey =
      error === 'noEntities' ? 'error.noEntities' : 'error.resolutionFailed';
    return (
      <div className={styles.wrapper}>
        <p className={styles.errorMessage}>{t(errorKey)}</p>
      </div>
    );
  }

  return null;
};
